import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ORIGINATOR_ID } from 'src/app/shared/enums/common.enum';
import { TradeHttpService } from '../services/trade-http.service';
import { SummaryByOriginatorResponseInterface } from 'src/app/shared/interfaces/summary-by-originator-response.interface';
import { numberValueFormatter } from 'src/app/shared/helpers/number-value-formatter';
import { COL_DEFS_Left, COL_DEFS_Right } from './constants/table.columns.const';
import { ColDef, GridReadyEvent } from '@ag-grid-community/core';
import { TradeTransactionsQueryParams } from 'src/app/shared/interfaces/trade-transactions-query-params';

@Component({
  selector: 'app-cash-reconcilation',
  templateUrl: './cash-reconcilation.component.html',
  styleUrls: ['./cash-reconcilation.component.scss'],
})
export class CashReconcilationComponent implements OnInit {
  originatorId = ORIGINATOR_ID;
  colDefs_Left: ColDef[] = COL_DEFS_Left(this);
  colDefs_Right: ColDef[] = COL_DEFS_Right(this);

  totalPage_Right = 0;
  recordsPerPage_Right = 100;
  totalRecords_Right = 0;
  totalRecordsDisplay_Right = '0';
  currentPageIndex_Right = 0;
  totalPageString_Right: string;
  paginationPageSize_Right = 50;

  totalPage_Left = 0;
  recordsPerPage_Left = 100;
  totalRecords_Left = 0;
  totalRecordsDisplay_Left = '0';
  currentPageIndex_Left = 0;
  totalPageString_Left: string;
  paginationPageSize_Left = 50;

  defaultColDef = {
    resizable: true,
    floatingFilter: false,
    filter: false,
    autoHeaderHeight: true,
  };
  queryParams: Partial<TradeTransactionsQueryParams> = {
    pageIndex: 0,
    perPage: 50,
    sort: 'settledDate',
    // originatorId: this.originatorId,
  };
  defaultQueryParams: Partial<TradeTransactionsQueryParams> = {
    ...this.queryParams,
  };
  rowData_Left: any[] = [];
  rowData_Right!: any[];
  totalFaceValue = '0';
  remainingValue = '0';
  tempRemainingValue = '0';
  receiptValue = '0';
  deduction: number | null = null;
  gridApi_Left: any;
  params_Left: any;
  gridApi_Right: any;
  params_Right: any;
  isShowAll = false;
  isTrailingBalance = false;
  isProcessButtonActive = true;
  isShowHide = false;
  isOriginator = false;
  parseFloat = parseFloat;
  constructor(
    public activeModal: NgbActiveModal,
    private tradeTransactionsHttpService: TradeHttpService,
  ) {}
  ngOnInit(): void {
    return;
  }
  onGridReady_Left(params: GridReadyEvent): void {
    this.gridApi_Left = params.api;
    this.params_Left = params;
    this.onGridRefresh();
  }

  onGridReady_Right(params: GridReadyEvent): void {
    this.gridApi_Right = params.api;
    this.params_Right = params;
    this.gridApi_Right.showNoRowsOverlay();
  }

  onGridRefresh() {
    this.getOriginators();
  }

  private getOriginators(): void {
    this.gridApi_Left.showLoadingOverlay();
    const queryparams = {
      // originatorId: this.originatorId.toLocaleString(),
    };
    this.tradeTransactionsHttpService
      .getCredebtorOverviewList(queryparams)
      .subscribe({
        next: (rowData) => {
          const formatData = (data: any[]) => {
            return data.map(
              (
                ele: SummaryByOriginatorResponseInterface | any,
                index: number,
              ) => {
                ele.id = index + 1;
                ele.selected = false;
                return ele;
              },
            );
          };
          let uniqueData = Array.from(
            new Map(
              rowData
                .filter((ele) => !!ele.debtorId)
                .map((ele) => [ele.debtorId, ele]),
            ).values(),
          );
          uniqueData = this.sortByName(uniqueData);
          uniqueData = formatData(uniqueData);
          this.rowData_Left = uniqueData.slice(0, 5);
          this.rowData_Left.push({
            isOriginator: true,
            debtorId: '11307000041',
            debtorName: 'The Tipperary Cheese Company Limited',
            receipt: 20000,
          });

          this.totalRecords_Left = this.rowData_Left.length;
          this.totalRecordsDisplay_Left =
            this.totalRecords_Left.toLocaleString('en-US');
          this.recordsPerPage_Left = this.rowData_Left.length;
          this.currentPageIndex_Left = 0;
          this.totalPage_Left = Math.ceil(
            this.totalRecords_Left / this.recordsPerPage_Left,
          );
          this.totalPageString_Left =
            this.totalPage_Left.toLocaleString('en-US');
        },
        error: (err: any) => {
          this.rowData_Left = [];
          this.gridApi_Left.showNoRowsOverlay();
        },
      });
  }

  private sortByName(items: any[]) {
    return items.sort((a, b) => {
      const nameA = a.debtorName?.trim().toLowerCase() || '';
      const nameB = b.debtorName?.trim().toLowerCase() || '';
      return nameA?.localeCompare(nameB);
    });
  }

  isProcessButtonActive2() {
    const totalFaceValueNum = Number(this.totalFaceValue.replace(/,/g, ''));
    const deductionNum = Number(this.deduction);
    const receiptValueNum = Number(this.receiptValue?.replace(/,/g, ''));
    if (totalFaceValueNum - deductionNum === receiptValueNum) {
      return true;
    } else {
      return false;
    }
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  bindTransactionDataToRight(): void {
    this.totalFaceValue = '0';
    const queryParams = {
      pageIndex: 0,
      perPage: 1000,
      originatorId: this.queryParams.originatorId,
      debtorId: this.queryParams.debtorId,
    };
    this.tradeTransactionsHttpService.getEtrByDebtor(queryParams).subscribe({
      next: (response) => {
        this.totalRecords_Right = response.meta.total;
        this.totalRecordsDisplay_Right =
          this.totalRecords_Right.toLocaleString('en-US');
        this.recordsPerPage_Right = response.meta.perPage;
        this.currentPageIndex_Right = response.meta.pageIndex;
        this.totalPage_Right = Math.ceil(
          this.totalRecords_Right / this.recordsPerPage_Right,
        );
        this.totalPageString_Right =
          this.totalPage_Right.toLocaleString('en-US');
        if (response.items.length) {
          const sortedData = response.items.sort(
            (a, b) =>
              new Date(b.tradedDate).getTime() -
              new Date(a.tradedDate).getTime(),
          );
          this.rowData_Right = sortedData;
        }

        this.gridApi_Right.hideOverlay();
      },
      error: (error) => {
        this.gridApi_Right.hideOverlay();
        this.rowData_Right = [];
      },
    });
  }

  getTradeTransactionsData(event: any): void {
    setTimeout(() => {
      this.totalFaceValue = '0';
    }, 10);
    this.deduction = null;
    this.isShowAll = false;
    this.isTrailingBalance = false;
    this.isProcessButtonActive = true;
    this.rowData_Right = [];
    this.receiptValue = event.data.receipt;
    if (event.data?.isOriginator) {
      this.isOriginator = true;
      setTimeout(() => {
        this.gridApi_Right.showLoadingOverlay();
      }, 0);
      this.isShowHide = false;
      this.queryParams = { ...this.queryParams, debtorId: '', perPage: 1000 };
      this.loadTransactionsData(this.queryParams);
    } else {
      this.isShowHide = true;
      this.isOriginator = false;
      if (event.data.debtorId) {
        setTimeout(() => {
          this.gridApi_Right.showLoadingOverlay();
        }, 0);
        this.queryParams = {
          ...this.queryParams,
          debtorId: event.data?.debtorId,
          originatorId: event.data?.originatorId,
          perPage: 1000,
        };
        this.bindTransactionDataToRight();
      }
    }
  }

  showTotalValue(event: any): void {
    const selectedRows = event.api.getSelectedRows();
    const sumFaceValue = selectedRows.reduce((value: number, row: any) => {
      const faceValue = row.faceValue || 0;
      return row.result?.type?.includes('Credit Note')
        ? value - faceValue
        : value + faceValue;
    }, 0);
    this.totalFaceValue = numberValueFormatter({ value: sumFaceValue });
    const totalFaceValueNum = this.totalFaceValue
      ? parseFloat(Number(this.totalFaceValue.replace(/,/g, '')).toFixed(2))
      : 0;
    const deductionNum = parseFloat(Number(this.deduction || 0).toFixed(2));
    const receiptValueNum = parseFloat(
      Number(this.receiptValue || 0).toFixed(2),
    );
    const remainingValue = parseFloat(
      (totalFaceValueNum - receiptValueNum || 0).toFixed(2),
    );
    this.remainingValue = numberValueFormatter({ value: remainingValue });
    this.tempRemainingValue = this.remainingValue;
    this.isProcessButtonActive =
      totalFaceValueNum - deductionNum !== receiptValueNum;
  }

  formatNegativeValue(value: any): string {
    const numericValue = parseFloat(value.replace(/,/g, ''));
    let formattedValue = Math.abs(numericValue).toFixed(2);
    if (isNaN(Number(formattedValue))) {
      return '0.00';
    }
    formattedValue = numberValueFormatter({ value: Number(formattedValue) });
    return formattedValue || '0.00';
  }

  onDeductionChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    let deductionValue = Number(inputElement.value);
    if (isNaN(Number(deductionValue))) {
      deductionValue = 0;
    }
    setTimeout(() => {
      if (Number(deductionValue) <= 0 && !this.isTrailingBalance) {
        inputElement.value = '';
        this.deduction = 0;
        this.remainingValue = this.tempRemainingValue;
      }
      const totalFaceValueNum = parseFloat(
        this.totalFaceValue.replace(/,/g, ''),
      );
      const receiptValueNum = parseFloat(this.receiptValue);
      let sumValue = 0;
      if (this.isTrailingBalance) {
        sumValue =
          Number(totalFaceValueNum) +
          (Number(deductionValue) < 0
            ? Number(deductionValue)
            : Number(deductionValue));
      } else {
        sumValue =
          Number(totalFaceValueNum) +
          (Number(deductionValue) < 0
            ? Number(deductionValue)
            : Number(deductionValue));
      }
      if (Number(sumValue) == Number(receiptValueNum)) {
        this.remainingValue = '0.00';
      } else {
        this.remainingValue = this.tempRemainingValue;
      }
      this.isProcessButtonActive = sumValue !== +receiptValueNum.toFixed(2);
    }, 200);
  }

  showAllCredebtors(event: any) {
    const isChecked = event.target.checked;
    if (isChecked) {
      setTimeout(() => {
        this.gridApi_Right.showLoadingOverlay();
      }, 0);
      this.queryParams = { ...this.queryParams, debtorId: '' };
      this.totalFaceValue = '0';
      this.loadTransactionsData(this.queryParams);
    } else {
      this.rowData_Right = [];
    }
  }

  onTrailingBalanceChange(event: any): void {
    this.isTrailingBalance = event.target.checked;
  }

  changePageSelection_Right(pageIndex: number) {
    if (this.isOriginator) {
      if (pageIndex >= 0 && pageIndex < this.totalPage_Right) {
        this.currentPageIndex_Right = pageIndex;
        this.queryParams['pageIndex'] = this.currentPageIndex_Right;

        setTimeout(() => {
          this.gridApi_Right.showLoadingOverlay();
        }, 0);
        this.isShowHide = false;
        this.queryParams = { ...this.queryParams, debtorId: '' };
        this.loadTransactionsData(this.queryParams);
      }
    }
  }

  onSortChanged_Right(event: any) {
    if (this.isOriginator) {
      event.api.showLoadingOverlay();
      const sortingState = this.gridApi_Right.getColumnState();
      const sortColumn = sortingState.filter(
        (item: any) => item.sort != null,
      )[0];
      if (sortColumn) {
        if (sortColumn.sort == 'asc')
          this.queryParams['sort'] = sortColumn.colId;
        else this.queryParams['sort'] = '-' + sortColumn.colId;
      } else {
        this.queryParams.sort = this.defaultQueryParams.sort;
      }

      this.loadTransactionsData(this.queryParams);
    }
  }

  loadTransactionsData(queryParams: any) {
    this.tradeTransactionsHttpService
      .getTradeTransactionsDataMultipleCall(queryParams)
      .subscribe({
        next: (response: any) => {
          this.totalRecords_Right = response.meta.total;
          this.totalRecordsDisplay_Right =
            this.totalRecords_Right.toLocaleString('en-US');
          this.recordsPerPage_Right = response.meta.perPage;
          this.currentPageIndex_Right = response.meta.pageIndex;
          this.totalPage_Right = Math.ceil(
            this.totalRecords_Right / this.recordsPerPage_Right,
          );
          this.totalPageString_Right =
            this.totalPage_Right.toLocaleString('en-US');
          if (response.items.length) {
            const formattedData = response.items;
            this.rowData_Right = formattedData;
          } else {
            this.rowData_Right = [];
          }
          this.gridApi_Right.hideOverlay();
        },
        error: (error) => {
          this.gridApi_Right.hideOverlay();
          this.rowData_Right = [];
        },
      });
  }

  getDynamicClass(rowCount: number): string {
    return rowCount > 6
      ? 'reconcile-responsive-default'
      : rowCount > 0
        ? `reconcile-responsive-${rowCount}`
        : 'reconcile-responsive-default';
  }
}
